export default {
  // Task checklists
  getForTask: (taskUuid) =>
    $nuxt.$axios.get(`${$nuxt.$api.host}/task/${taskUuid}/checklists`),
  createForTask: (taskUuid, data) =>
    $nuxt.$axios.post(`${$nuxt.$api.host}/task/${taskUuid}/checklists`, data),

  // Workflow task checklists
  getForWorkflowTask: (workflowUuid, taskUuid) =>
    $nuxt.$axios.get(`${$nuxt.$api.host}/workflow/${workflowUuid}/task/${taskUuid}/checklists`),
  createForWorkflowTask: (workflowUuid, taskUuid, data) =>
    $nuxt.$axios.post(`${$nuxt.$api.host}/workflow/${workflowUuid}/task/${taskUuid}/checklists`, data),

  // Checklist CRUD
  updateChecklist: (checklistUuid, data) =>
    $nuxt.$axios.patch(`${$nuxt.$api.host}/checklist/${checklistUuid}`, data),
  deleteChecklist: (checklistUuid) =>
    $nuxt.$axios.delete(`${$nuxt.$api.host}/checklist/${checklistUuid}`),

  // Checklist item CRUD
  createItem: (checklistUuid, data) =>
    $nuxt.$axios.post(`${$nuxt.$api.host}/checklist/${checklistUuid}/items`, data),
  updateItem: (itemUuid, data) =>
    $nuxt.$axios.patch(`${$nuxt.$api.host}/checklist-item/${itemUuid}`, data),
  deleteItem: (itemUuid) =>
    $nuxt.$axios.delete(`${$nuxt.$api.host}/checklist-item/${itemUuid}`),
};
